export default "__VITE_ASSET__CfJfpex3__"